<template>
  <table class="table-auto">
    <thead>
      <tr>
        <th scope="col" class="sr-only">Day of the week</th>
        <th v-for="time in allTimes" :key="time" scope="col" class="text-body text-center pt-8 pb-8 w-1/4">
          <span class="capitalize">{{ time }}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="day in allDays" :key="day" class="border-solid border-b-1 border-grey-divider-subdued last:border-b-0">
        <th scope="row" class="text-body text-left capitalize">{{ day.substring(0, 3) }}</th>
        <td v-for="time in allTimes" :key="time" class="pt-8 pb-8">
          <div class="flex justify-center">
            <TickIcon v-if="availability[day] && availability[day].includes(time)" color="#229150" aria-label="Is available" />
            <CloseIcon v-else :width="16" :height="16" color="#CE1B04" aria-label="Is not available" />
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import TickIcon from '@/graphics/icons/TickIcon.vue';
import CloseIcon from '@/graphics/icons/CloseIcon.vue';

export default {
  name: 'AvailabilityTable',
  components: {
    TickIcon,
    CloseIcon,
  },
  props: {
    availability: {
      default: () => {},
      type: Object,
    },
  },
  computed: {
    allTimes(): String[] {
      return ['morning', 'afternoon', 'evening'];
    },
    allDays(): String[] {
      return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    },
  },
};
</script>
